import { CompareActions, ProductErrorState, UserActionState } from '../types';

export const INITIAL_PRODUCT_ERROR_STATE: ProductErrorState = {
  error: null,
  productId: '',
  groupId: '',
};

export const INITIAL_USER_ACTION_STATE: UserActionState = {
  action: CompareActions.REQUEST,
  productId: '',
  familyId: '',
  groupId: '',
  groupName: '',
};
